export class NoteLoggerViewModel
{
    opened: boolean = false;

    show()
    {
        this.opened = true;
    }

    close()
    {
        this.opened = false;
    }
}